import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WimOperationalQualityI } from '../types/platforms';

type InitialState = {
  isLoading: boolean;
  wimOperationalQuality: WimOperationalQualityI[] | null;
  error: any;
};

const initialState: InitialState = {
  isLoading: false,
  wimOperationalQuality: null,
  error: null,
};

const wimOperationalQuality = createSlice({
  name: 'wimOperationalQuality',
  initialState,
  reducers: {
    requestWimOperationalQuality: (state, { payload }: PayloadAction<any>): void => {
      state.isLoading = true;
    },
    getWimOperationalQualitySuccess: (state, { payload }: PayloadAction<WimOperationalQualityI[]>): void => {
      state.isLoading = false;
      state.wimOperationalQuality = payload;
    },
    getWimOperationalQualityError: (state, { payload }: PayloadAction<string>): void => {
      state.isLoading = false;
      state.error = payload;
    },
  },
});

export const { requestWimOperationalQuality, getWimOperationalQualitySuccess, getWimOperationalQualityError } =
  wimOperationalQuality.actions;

export default wimOperationalQuality.reducer;
